import {
  binCountSessionIdFormat,
  locationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getActiveBinCountSession = {
  name: "getActiveBinCountSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z
    .object({
      binCountSessionId: binCountSessionIdFormat.schema,
      totalBins: z.number(),
      completedBins: z.number(),
    })
    .nullable(),
};
